/**
 * Button — primary action button.
 * Variants: 'primary' (navy fill, default), 'secondary' (outlined), 'danger'.
 */
export default function Button({
  children,
  variant = 'primary',
  type = 'button',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const base = 'inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'

  const variants = {
    primary:   'bg-ghasc-navy text-white hover:bg-ghasc-navy-light focus:ring-ghasc-navy',
    secondary: 'bg-white text-ghasc-navy border border-ghasc-navy hover:bg-gray-50 focus:ring-ghasc-navy',
    danger:    'bg-ghasc-danger text-white hover:bg-red-700 focus:ring-ghasc-danger',
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    >
      {loading && <span className="spinner w-4 h-4 mr-2" />}
      {children}
    </button>
  )
}
